import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgRepair = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M.678.435h24v24h-24z" />
      <path
        d="M23.678 8.035a6.6 6.6 0 0 1-9.686 5.835l-9.564 9.565-2.75-2.75 9.564-9.565A6.6 6.6 0 0 1 20.163 2.2l-4.185 4.186 2.75 2.75 4.185-4.186c.488.92.765 1.97.765 3.086Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgRepair)
const Memo = memo(ForwardRef)
export default Memo
